<template>
    <div style="width:600px;height:600px" @click="doPlayer">
        <video id="video" playsinline webkit-playsinline preload="auto" ></video>
    </div>
</template>
<script setup>
import { ref, reactive, getCurrentInstance } from 'vue'
// @link https://developer.qiniu.com/pili/4621/web-player-sdk
const player = ref(null);
const playing = ref(false);

const init = (config) => {
    loadDependencyScript(() => {
        createPlayer(config)
    })
};
const loadDependencyScript = (callback) => {
    loadScript(callback, {
        id: 'qiniuPlayerScriptId',
        url: process.env.VUE_APP_BASE_PATH+'js/qiniu-web-player-1.2.3.js'
        // url: 'https://sdk-release.qiniushawn.top/qiniu-web-player-1.2.3.js'
    })
};
const loadScript = (callback, params) => {
    if (document.getElementById(params.id)) {
        callback()
    } else {
        const script = document.createElement('script')
        script.async = true
        script.src = params.url
        script.id = params.id
        script.onload = () => {
            callback()
        }
        document.body.appendChild(script)
    }
};
const createPlayer = async (config) => {
    // 获取签名vide地址
    player.value = new QPlayer(Object.assign({
        url: "",
        container: document.getElementById("video"),
        autoplay: true,
        loggerLevel: 0,
        defaultViewConfig: {
            noControls: true
        }
    }, config));
    // 注册 ready 的监听函数
    player.value.on("ready", function() {
        console.log("播放器准备就绪");
    });
    player.value.on("error", function(e) {
        console.log("error", e);
    });
    player.value.on("ended", function() {
        console.log("播放结束");
    });
    player.value.on("timeupdate", function(currentTime, totalTime) {
        console.log("播放时间更新", currentTime, totalTime);
    })
    player.value.on("seeked", function(){
        console.log("播放器跳转完成");
    })

};
const doPlayer = () => {
    console.log("doPlayer");

    if (!playing.value) {
        playing.value = true;
        player.value.play();
        player.value.seek(2);
    } else {
        playing.value = false;
        player.value.pause();
    }
}
// 父组件使用的话需要导出
defineExpose({
  init,
});
</script>